var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        visible: true,
        title: "Фактически выполненные работы",
        size: "lg",
        centered: "",
        "hide-footer": "",
        "no-close-on-backdrop": _vm.saving,
        "no-close-on-esc": _vm.saving,
        "hide-header-close": _vm.saving
      },
      on: { hide: _vm.onHide }
    },
    [
      _c(
        "form",
        {
          staticClass: "work-form",
          attrs: { novalidate: "" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.confirm.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "work-tabs",
              attrs: { role: "tablist", "aria-label": "Данные смены" }
            },
            _vm._l(_vm.tabs, function(tab) {
              return _c(
                "button",
                {
                  key: tab.id,
                  class: { active: _vm.activeTab === tab.id },
                  attrs: {
                    type: "button",
                    role: "tab",
                    "aria-selected": _vm.activeTab === tab.id
                  },
                  on: {
                    click: function($event) {
                      _vm.activeTab = tab.id
                    }
                  }
                },
                [_vm._v(_vm._s(tab.label))]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("p", { staticClass: "work-performer" }, [
            _vm._v(
              _vm._s(_vm.entry.worker_name) +
                " · Заявка №" +
                _vm._s(_vm.entry.task_id)
            )
          ]),
          _vm._v(" "),
          _c(
            "b-alert",
            {
              attrs: {
                show: !!_vm.error || !!_vm.validationError,
                variant: "warning"
              }
            },
            [_vm._v(_vm._s(_vm.validationError || _vm.error))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "work",
                  expression: "activeTab === 'work'"
                }
              ],
              staticClass: "work-columns"
            },
            _vm._l(["plan", "actual"], function(side) {
              return _c(
                "section",
                {
                  key: side,
                  staticClass: "work-panel",
                  attrs: {
                    "aria-label":
                      side === "plan"
                        ? "Запланированные работы"
                        : "Выполненные работы"
                  }
                },
                [
                  _c("h5", [
                    _vm._v(
                      _vm._s(
                        side === "plan"
                          ? "Запланированные работы"
                          : "Выполненные работы"
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v("Время начала\n          "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.values[side].start,
                          expression: "values[side].start"
                        }
                      ],
                      attrs: {
                        type: "datetime-local",
                        disabled: side === "plan" || _vm.saving,
                        step: "60",
                        required: ""
                      },
                      domProps: { value: _vm.values[side].start },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.values[side],
                            "start",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v("Время окончания\n          "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.values[side].end,
                          expression: "values[side].end"
                        }
                      ],
                      attrs: {
                        type: "datetime-local",
                        disabled: side === "plan" || _vm.saving,
                        step: "60",
                        required: ""
                      },
                      domProps: { value: _vm.values[side].end },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.values[side], "end", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v("Формат выхода"),
                    _c("input", {
                      attrs: { disabled: "" },
                      domProps: { value: _vm.employmentLabel }
                    })
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v("Вид работ"),
                    _c("input", {
                      attrs: { disabled: "" },
                      domProps: {
                        value: _vm.entry.work_name || "Работы по заявке"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v("Кол-во\n          "),
                    _c("span", { staticClass: "work-quantity" }, [
                      _c("span", { staticClass: "work-input-unit" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: _vm.values[side].total_units,
                              expression: "values[side].total_units",
                              modifiers: { number: true }
                            }
                          ],
                          attrs: {
                            type: "number",
                            min: "0",
                            max: "1000000000",
                            step: "any",
                            disabled: side === "plan" || _vm.saving,
                            required: ""
                          },
                          domProps: { value: _vm.values[side].total_units },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.values[side],
                                "total_units",
                                _vm._n($event.target.value)
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.unitLabel))])
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { disabled: "", "aria-label": "Ставка" },
                        domProps: {
                          value:
                            _vm.formatNumber(_vm.values[side].price) +
                            " ₽/" +
                            _vm.unitLabel
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.values[side].services, function(service) {
                    return _c(
                      "div",
                      { key: service.id, staticClass: "work-service" },
                      [
                        _c("label", [
                          _vm._v("Услуги исполнителя"),
                          _c("input", {
                            attrs: { disabled: "" },
                            domProps: { value: service.name }
                          })
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _vm._v("Кол-во\n            "),
                          _c("span", { staticClass: "work-quantity" }, [
                            _c("span", { staticClass: "work-input-unit" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: service.quantity,
                                    expression: "service.quantity",
                                    modifiers: { number: true }
                                  }
                                ],
                                attrs: {
                                  type: "number",
                                  min: "0",
                                  max: "1000000000",
                                  step: "any",
                                  disabled: side === "plan" || _vm.saving,
                                  required: ""
                                },
                                domProps: { value: service.quantity },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      service,
                                      "quantity",
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(service.unit_name || _vm.unitLabel)
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                disabled: "",
                                "aria-label": "Ставка услуги"
                              },
                              domProps: {
                                value: _vm.formatNumber(service.price) + " ₽"
                              }
                            })
                          ])
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "section",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "expenses",
                  expression: "activeTab === 'expenses'"
                }
              ],
              staticClass: "work-panel work-expenses",
              attrs: { "aria-label": "Расходы по исполнителю" }
            },
            [
              _vm._l(_vm.expenses, function(expense) {
                return _c("label", { key: expense.key }, [
                  _vm._v(_vm._s(expense.label) + "\n        "),
                  _c("span", { staticClass: "work-input-unit" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.values.actual[expense.key],
                          expression: "values.actual[expense.key]",
                          modifiers: { number: true }
                        }
                      ],
                      attrs: {
                        type: "number",
                        min: "0",
                        max: "1000000000",
                        step: "0.01",
                        placeholder: "Сумма",
                        disabled: _vm.saving,
                        required: ""
                      },
                      domProps: { value: _vm.values.actual[expense.key] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.values.actual,
                            expense.key,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    _c("span", [_vm._v("₽")])
                  ])
                ])
              }),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Обед, трансфер и другие расходы включаются в сумму с заказчика. Аванс вычитается из остатка выплаты исполнителю."
                )
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "work-footer" }, [
            _c(
              "button",
              {
                staticClass: "custom-btn-secondary",
                attrs: { type: "button", disabled: _vm.saving },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [_vm._v("Отменить")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "custom-btn-primary",
                attrs: { type: "submit", disabled: _vm.saving }
              },
              [_vm._v(_vm._s(_vm.saving ? "Сохранение…" : "Подтвердить"))]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e16ff440", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e16ff440","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TaskTimesheetWorkModal.vue
// module id = null
// module chunks = 